<template>
    <div class="error-details ma-0">
        <div class="text">
            <h1 class="display-1 pr-3 mr-3">{{ error }}</h1>
            <div class="desc">
                <h2 class="body-2">
                    <span>{{ msg }}</span>
                    <span>.</span>
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',
        data() {
            return {
                title: 'Not Found',
                error: 404,
                msg: 'Not Found',
            };
        },
        created() {
            this.$store.commit('nav/BREADCRUMBS', []);
        },
    };
</script>

<style scoped lang="stylus">
    .error-details
        top: 0
        bottom: 0
        left: 0
        right: 0
        position: absolute
        text-align: center
        padding-top: 20%

    h1, .desc
        display: inline-block
        vertical-align: middle

    h1
        border-right: 1px solid rgba(0, 0, 0, .3)
        font-weight: 700
</style>



// WEBPACK FOOTER //
// NotFound.vue?5466f849